export default "__VITE_ASSET__4d06f72a__"